import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { GraphToolbarDropdown } from 'components/Graph/GraphToolbar/GraphToolbarDropdown';
import { selectGraphToolbarDisabled } from 'components/Graph/GraphToolbar/selectors/selectGraphToolbarDisabled';
import { DownloadIcon } from 'components/icons/DownloadIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { exportToPng } from '../commands/rendering/exportToPng';
import { exportToSvg } from '../commands/rendering/exportToSvg';
import { exportToVsdx } from '../commands/rendering/exportToVsdx';

export const GraphToolbarExportMenu: FC = () => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    disabled: selectGraphToolbarDisabled,
  });
  const [exporting, setExporting] = useLoadingState();

  return (
    <GraphToolbarDropdown
      title={msg.canvasGraph.graphToolbar.buttons.export}
      disabled={exporting === 'LOADING'}
      disabledTitle={msg.canvasGraph.graphToolbar.buttons.selectDataToDisplay}
      options={[
        {
          disabled: ctxProps.disabled,
          label: msg.canvasGraph.graphToolbar.buttons.exportToSvg,
          onClick: () => {
            ctxProps.dispatch(exportToSvg);
          },
        },
        {
          disabled: ctxProps.disabled,
          label: msg.canvasGraph.graphToolbar.buttons.exportToPng,
          onClick: () => {
            ctxProps.dispatch(exportToPng);
          },
        },
        {
          disabled: ctxProps.disabled,
          label: msg.canvasGraph.graphToolbar.buttons.exportToVsdx,
          onClick: () => {
            withLoadingIndicator(setExporting)(() =>
              ctxProps.dispatch(exportToVsdx),
            );
          },
        },
      ]}
    >
      {exporting === 'LOADING' ? (
        <Icon loading={true} glyph='fa-spinner' size='xs' />
      ) : (
        <DownloadIcon title='Download' width={16} height={16} />
      )}
    </GraphToolbarDropdown>
  );
};
